import {resources} from "../../../../../../../core/models/resource/resources";

export const certificateResourceType = resources['certificates'];
export const certificateFilesResourceType = resources['certificate-files'];
